import type { PropsWithChildren } from "react";
import { CompleteOnboarding } from "ui/forms/ECommerce";
import { OnboardingComplete, withApplication, type StepProps } from "ui/organizms/ECommerce/Onboarding/common";
import useComplete from "./useComplete";

const Complete = ({ slots, children }: PropsWithChildren<StepProps>) => (
    <OnboardingComplete
        slots={{
            ...slots,
            form: (
                <CompleteOnboarding.Form
                    {...useComplete()}
                />
            )
        }}
    >
        {children}
    </OnboardingComplete>
);

export default withApplication(Complete);
